import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { shopAllAction } from './actions';
import styles from './SearchResults.module.css';

const SearchResults = ({
  searchQuery,
  resultSize,
  updateShowSearchBar,
  resetSearch,
  selectedCategoryId,
}) => {
  const history = useHistory();
  const getResetSearchLink = (text, showSearchBar) => {
    return (
      <button
        type="button"
        className={`naked-button ff-ns fw-light pad-0 mar-0 ${styles.shopAllButton}`}
        onClick={() =>
          showSearchBar
            ? updateShowSearchBar(showSearchBar)
            : shopAllAction(history, selectedCategoryId, resetSearch)
        }
      >
        {text}
      </button>
    );
  };

  if (!searchQuery) return null;

  return (
    <div className={`${styles.container} page-row`}>
      <p className={styles.resultsCountText}>
        We found{' '}
        <strong>
          {resultSize} {resultSize === 1 ? 'result' : 'results'}
        </strong>{' '}
        for <span>&quot;{searchQuery}&quot;</span>
      </p>
      <div className={styles.backToAllText}>
        {resultSize > 0 ? (
          `Can’t find what you’re looking for? `
        ) : (
          <span>Try {getResetSearchLink('Search', true)} again or </span>
        )}
        {getResetSearchLink('Shop All', false)}
      </div>
    </div>
  );
};

SearchResults.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  resultSize: PropTypes.number.isRequired,
  selectedCategoryId: PropTypes.string,
  updateShowSearchBar: PropTypes.func.isRequired,
  resetSearch: PropTypes.func.isRequired,
};

SearchResults.defaultProps = {
  selectedCategoryId: null,
};

export default SearchResults;
